import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ResetButton from "./ResetButton";
import ReactSelectAdapter from "./ReactSelectAdapter";

export default class IndependentSelector extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOption: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        onChange: PropTypes.func,
        resetFunction: PropTypes.func,
        disabled: PropTypes.bool,
        isMulti: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool
    };

    render() {
        const {name, defaultOptionLabel, options, selectedOption, onChange, resetFunction, disabled, isMulti, hasSpecialIcon} = this.props;

        const castSelectedOption = isNaN(selectedOption) ? selectedOption : parseInt(selectedOption, 10);

        return (
            <React.Fragment>
                <div className={'selectCustom'}>
                    <ReactSelectAdapter
                        selectedOption={castSelectedOption}
                        name={name}
                        options={options}
                        onChange={onChange}
                        disabled={disabled}
                        defaultOptionLabel={defaultOptionLabel}
                        isMulti={isMulti}
                        hasSpecialIcon={hasSpecialIcon}
                    />
                    {resetFunction &&
                        <ResetButton reset={resetFunction} value={selectedOption} filterKey={name} />
                    }
                </div>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/IndependentSelector.js